import React, { useEffect, useState} from "react";
import ModalCheckCode from "component/ModalCheckCode"
import Empadronamiento from '../Empadronamiento/index';
import { connect } from "react-redux";
import mapDispatchToProps from "./mapDispatchToProps";
import mapStateToProps from "./mapStateToProps";
import HasPhoneNumberModal from "./HasPhoneNumberValidatorModal";

const CodeValidadorToGeoAccess = (props) => {
  const [modalPhoneCode, setModalPhoneCode] = useState(false);
  const [modalHasNotPhoneNumber, setModalHasNotPhoneNumber] = useState(false);
  const [codeIsValid, setCodeIsValid] = useState(false);

  let body = {
    phoneNumber: props.currentUser.numero_telefonico,
    firstName: props.currentUser.name,
  }

  // Si el código es correcto, cerramos modal de validación y seteamos bandera para que renderice a "Empadronamiento".
  const nextScreen =()=>{
    setCodeIsValid(true);
    setModalPhoneCode(false)
  }

  const closeModalCheckCode = () => {
    setModalPhoneCode(false)
  };

  // Abrimos el modal cuando hagan clic en la opcion de "Empadronamiento"
  useEffect(()=>{
    // Si no tiene número de telefóno envia al usuario a ingresar uno.
    if (!props.currentUser.numero_telefonico) return setModalHasNotPhoneNumber(true)

    let dialCode = props.currentUser.numero_telefonico.slice(0, 3); // Entraemos el dialCode del número.

    // Si es número nacional, enviamos código de lo contrario que omita el 2FA.
    dialCode === "502"
    ? setModalPhoneCode(true)
    : nextScreen(true);
  }, [])

  return(
    <div>
      {modalHasNotPhoneNumber && 
        <HasPhoneNumberModal 
          open={modalHasNotPhoneNumber}
          handleClose={()=>setModalHasNotPhoneNumber(false)}
        />
      }
      {codeIsValid ?
        <Empadronamiento/>
        :
        <ModalCheckCode
          open={modalPhoneCode}
          closeModal={closeModalCheckCode}
          userData={body}
          nextProcess={nextScreen}
          seeCloseButton={true}
        />
      }
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(CodeValidadorToGeoAccess);